import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { TitleContext } from '@providers/TitleProvider'
import { useSession } from '@stores/globalData/globalData.store'
import { isLearnPcPreview } from '@utils/page-routes'

const NumberFollowers: React.FC = () => {
  const { t } = useTranslation()
  const { title } = useContext(TitleContext)
  const session = useSession()
  const { pathname } = useLocation()

  if (!title.seller || !session.isDefaultCommunity() || isLearnPcPreview(pathname)) {
    return null
  }

  return (
    <p className="text-sm">
      {t('content.followersWithCount', { count: title.seller.follower_count })}
    </p>
  )
}

export default NumberFollowers
